import { SVGProps } from 'react';

export const MicrophoneIcon = (props: SVGProps<SVGSVGElement>) => {
  // The mic path is 10×16; a square viewBox centres it in a 16×16 box.
  return (
    <svg width="16" height="16" viewBox="-3 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M1.13672 7.47949C1.14957 9.54692 2.82896 11.2188 4.89941 11.2188C6.96986 11.2187 8.64926 9.54692 8.66211 7.47949H9.8457C9.84559 9.9734 7.9911 12.0326 5.58594 12.3564V16H4.26074V12.3564C1.85518 12.0329 0.000109691 9.97365 0 7.47949H1.13672ZM4.92285 0C6.36074 0 7.52635 1.16563 7.52637 2.60352V7.66895H7.51758C7.42036 9.01823 6.29692 10.083 4.92285 10.083C3.5489 10.0829 2.42633 9.01814 2.3291 7.66895H2.31934V2.60352C2.31935 1.16571 3.48507 0.000121756 4.92285 0ZM4.92285 1.13574C4.04992 1.13586 3.34147 1.83135 3.31641 2.69824H3.31348V7.62207H3.32129C3.39915 8.43828 4.08627 9.07703 4.92285 9.07715C5.75953 9.07715 6.44653 8.43835 6.52441 7.62207H6.53223V2.69824H6.53027C6.50522 1.83127 5.79589 1.13574 4.92285 1.13574Z"
        fill="currentColor"
      />
    </svg>
  );
};
